import { rupees } from 'config/utils';
import { getVariantAmountMap, getInitialStateTotalAmount } from '../../utils/GlobalUtils';
import sanitizePaymentOptions, {
  getSupportedPaymentInstruments,
} from './paymentOptions';

import {
  getIsMobileDevice,
} from 'utils/ModernizrUtils';

const getOfferInitialState = (state, baseInitialState) => {
  const {
    should_retry: shouldRetry,
  } = state;
  const updatedState = shouldRetry ? state.retry_data : state;
  const {
    base_price: basePrice,
    prefilled: {
      total_amount: {
        value: totalAmount,
      } = {},
    } = {},
  } = updatedState.offer;

  const {
    discount_amount: discountAmount,
  } = updatedState.discount;

  const {
    is_direct_to_payments: isDirectToPayments,
  } = updatedState;

  // ALl Initial Form props that can affect the totalAmount
  const initialFormFields = {
    discountAmount,
  };

  const initialAmount = isDirectToPayments ?
    totalAmount ? totalAmount : getInitialStateTotalAmount()
    : getInitialStateTotalAmount();

  const initialState = {
    ...baseInitialState,
    isLinkPayment: false,
    totalAmount: initialAmount,
    totalAmountFormatted: rupees(initialAmount),
    offer: {
      basePrice,
      variantAmountMap: getVariantAmountMap(),
    },
    form: initialFormFields,
    isMobileDevice: getIsMobileDevice(),
  };

  if (isDirectToPayments) {
    const supportedPaymentInstruments = getSupportedPaymentInstruments(
      updatedState.offer.payment_forms
    );

    return {
      ...initialState,
      selectedBankId: '',
      ...sanitizePaymentOptions(supportedPaymentInstruments),
    };
  }

  if (shouldRetry) {
    const supportedPaymentInstruments = getSupportedPaymentInstruments(
      state.payment.payment_forms
    );

    return {
      ...initialState,
      selectedBankId: '',
      ...sanitizePaymentOptions(supportedPaymentInstruments),
    };
  }

  return initialState;
};

export default getOfferInitialState;



// WEBPACK FOOTER //
// ./src/payments/reducers/finalize/offerInitialState.js